import { getApiClient } from "@punchup/utils/apiRegistry";

export async function syncContactInfoToCourier(): Promise<void> {
  await getApiClient().post("/api/v2/user/contact-info/sync", {});
}
